
import { chains } from "./wagmiConfig";
import { Chain } from "viem";

export const chainId = Number(import.meta.env.VITE_CHAIN_ID);
export const worldAddress = import.meta.env.VITE_WORLD_ADDRESS;
export const startBlock = BigInt(import.meta.env.VITE_START_BLOCK ?? 0);

export const url = new URL(window.location.href);



export function getWorldAddress() {
  if (!worldAddress) {
    throw new Error("No world address configured. Is the world still deploying?");
  }
  return worldAddress;
}

export function getChain(): Chain {
  const chain = chains.find((c) => c.id === chainId);
  if (!chain) {
    throw new Error(`No chain configured for chain ID ${chainId}.`);
  }
  return chain;
}
